// eslint-disable-next-line no-shadow
export enum MediaGenerationStatus {
	PENDING = 'pending',
	INITIATED = 'initiated',
	SUCCESS = 'success',
	FAILED = 'failed',
}
